import { render, staticRenderFns } from "./OrganisationDomainLinks.vue?vue&type=template&id=41f35cc0&"
import script from "./OrganisationDomainLinks.vue?vue&type=script&lang=ts&"
export * from "./OrganisationDomainLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports